<template>
  <div class="role-list-static">
    <template v-for="(role, idx) in localRoles">
      <div class="role-row" :key="role.id || idx" v-if="!role.is_deleted">
        <date-range-picker
          :value="[
            role.start_at ? new Date(role.start_at) : null,
            role.end_at ? new Date(role.end_at) : null,
          ]"
          dateFormat="Y/m/d"
          placeholder=""
          @update:value="
            val => {
              updateRange(val, idx);
              $emit('editing');
            }
          "
          :customStyle="{
            height: '43px',
            borderRadius: '2px',
            fontWeight: '600',
            color: 'inherit',
          }"
          arrowIconRight="top:11px;"
          :arrowIconSvgClasses="'h-6 w-6'"
        />
        <vs-select
          v-model="role.manning_vessel_crew_responsibility_id"
          :key="idx"
          @change="$emit('editing')"
        >
          <vs-select-item
            icon="arrow_downward"
            v-for="res in crewResposibilities"
            :key="res.id"
            :value="res.id"
            :text="res.name"
          />
        </vs-select>
        <button class="role-delete-btn" @click="removeRole(idx)">
          <img
            src="@/assets/images/manning-vessel-crew/delete.svg"
            alt="Delete Role"
          />
        </button>
      </div>
    </template>
    <div class="role-add-row" @click="addRole">
      <img src="@/assets/images/manning-vessel-crew/add.svg" alt="Add Role" />
      <span>役割を追加</span>
    </div>
    <FormButtonList
      :activeSave="activeSave"
      @save="onSave"
      @cancel="onCancel"
    />
  </div>
</template>
<script>
import FormButtonList from "./FormButtonList.vue";
import EnterpriseManningVesselCrewReposibilitiesService from "../../../services/master/EnterpriseManningVesselCrewResposibilitiesService";
import DateRangePicker from "@/views/enterprise/management/crews/components/DateRangePicker.vue";

export default {
  components: { FormButtonList, DateRangePicker },
  props: {
    crewResposibilitiesList: {
      type: Array,
      default: () => [],
    },
    crewResposibilities: {
      type: Array,
      default: () => [],
    },
    crewId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      activeSave: true,
      localRoles: [...this.crewResposibilitiesList],
    };
  },
  watch: {
    localRoles: {
      handler: function() {
        for (const role of this.localRoles) {
          if (
            !role.start_at ||
            !role.end_at ||
            !role.manning_vessel_crew_responsibility_id
          ) {
            this.activeSave = false;
            return;
          }
        }
        this.activeSave = true;
      },
      deep: true,
    },
    crewResposibilitiesList(newVal) {
      this.localRoles = [...newVal];
    },
  },
  methods: {
    formatDatePicker(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },
    updateRange(val, idx) {
      this.localRoles[idx].start_at = val && val[0] ? this.toYMD(val[0]) : "";
      this.localRoles[idx].end_at = val && val[1] ? this.toYMD(val[1]) : "";
    },
    addRole() {
      this.localRoles.push({
        manning_vessel_crew_responsibility_id: "",
        start_at: "",
        end_at: "",
      });
      this.$nextTick(() => {
        window.dispatchEvent(new Event("resize"));
      });
    },
    removeRole(idx) {
      const role = this.localRoles[idx];
      // idがない場合はローカルリストから削除
      if (!role.id) {
        this.localRoles.splice(idx, 1);
        return;
      }
      // idがある場合はis_deletedフラグを立てる
      this.$set(this.localRoles, idx, {
        ...this.localRoles[idx],
        is_deleted: true,
      });
      this.$emit("editing");
    },
    toYMD(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
    async onSave() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "保存",
        text: "保存しますか？",
        cancelText: "キャンセル",
        acceptText: "OK",
        accept: async () => {
          try {
            const roles = this.localRoles.map(r => ({
              ...r,
              start_at: this.toYMD(r.start_at),
              end_at: this.toYMD(r.end_at),
            }));
            await EnterpriseManningVesselCrewReposibilitiesService.update(
              this.crewId,
              { responsibilities: roles }
            );
            this.$emit("saved");
          } catch (e) {
            this.$emit("save-failed");
          }
        },
        cancel: () => {},
      });
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
.role-list-static {
  padding: 16px;
  font-size: 12px;
  font-weight: 600;
}

.flatpickr-input {
  height: 43px;
}

.vdp-datepicker {
  input {
    width: 100%;
    border: none;
    background: transparent;
    font-size: 14px;
    outline: none;
  }
}

.role-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 12px;
}

::v-deep .con-select .vs-select--input {
  height: 43px !important;
  width: 180px !important;
  font-weight: 600;
}

::v-deep .vs-select--icon {
  right: 10px;
  font-size: 24px;
  color: #9ea2a7;
}

.role-delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #b0b0b0;
  font-size: 20px;
  padding: 0 6px;
}

.role-add-row {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #222;
  margin: 18px 0 18px 0;
  gap: 8px;
}

.role-add-row .icon-plus {
  font-size: 20px;
  color: #03a9f4;
}

.role-actions {
  display: flex;
  gap: 18px;
  margin-top: 18px;
}
</style>
